import { TypeOfPurchase } from '../enums/TypeOfPurchase';
import { SlotPackage } from '../enums/SlotPackage';

export const TYPE_OF_PURCHASE_TRANSFORM_MAP: Record<string, TypeOfPurchase> = {
  'GP Class 1': TypeOfPurchase.GP_CLASS_1,
  'GP SOV': TypeOfPurchase.GP_SOV,
  NGP: TypeOfPurchase.NGP,
};

export const SLOT_PACKAGE_NAME_TRANSFORM_MAP: Record<string, SlotPackage> = {
  'MOBILE DETAILS': SlotPackage.MOBILE_DETAILS,
  'MOBILE DETAILS ENCORE': SlotPackage.MOBILE_DETAILS_ENCORE,
  'DESKTOP DETAILS': SlotPackage.DESKTOP_DETAILS,
  'DESKTOP SEARCH LEFT': SlotPackage.DESKTOP_SEARCH_LEFT,
  MCONTEXTUAL: SlotPackage.M_CONTEXTUAL,
  DCONTEXTUAL: SlotPackage.D_CONTEXTUAL,
  'MCONTEXTUAL CLASS 1 CPM': SlotPackage.M_CONTEXTUAL_CLASS_1_CPM,
  'DCONTEXTUAL CLASS 1 CPM': SlotPackage.D_CONTEXTUAL_CLASS_1_CPM,
  'ILM CLASS 1': SlotPackage.ILM_CLASS_1,
  'PPP CLASS 1': SlotPackage.PPP_CLASS_1,
  'WP CLASS 1': SlotPackage.WP_CLASS_1,
  'WD2 TARGETED CLASS 1': SlotPackage.WD2_TARGETED_CLASS_1,
  'ROS DSP UNGUARANTEED': SlotPackage.ROS_DSP_UNGUARANTEED,
  'Star Package': SlotPackage.STAR_PACKAGE,
  'STAR PACKAGE': SlotPackage.STAR_PACKAGE,
  IM: SlotPackage.STAR_PACKAGE,
  'SEARCH BTF DSP': SlotPackage.SEARCH_BTF_DSP,
  'HQP CLASS 1': SlotPackage.HQP_CLASS_1,
  'HQP + ILM DSP': SlotPackage.HQP_ILM_DSP,
  GATEWAY: SlotPackage.GATEWAY,
  mThankyou: SlotPackage.MTHANKYOU,
  MTHANKYOU: SlotPackage.MTHANKYOU,
  'CPG-MTHANKYOU': SlotPackage.MTHANKYOU,
  MobileHQPSOV: SlotPackage.MOBILE_HQP_SOV,
  MOBILEHQPSOV: SlotPackage.MOBILE_HQP_SOV,
};
